<template>
  <section id="total_reward_description">
    <div class="container">
      <div class="title_wrapper">
        <p>
          <span
            ><img
              :src="
                imageUrl +
                'total_reward_description_title.webp?x-oss-process=image/format,webp'
              "
              alt=""
          /></span>
        </p>
      </div>
      <div class="content_wrapper">
        <div class="content">
          <p class="title">
            {{ $t("promotion.totalRewardDescription.description") }}
          </p>
          <img
            :src="
              imageUrl + 'USD_2,000,000.webp?x-oss-process=image/format,webp'
            "
            alt=""
          />
        </div>
        <img
          :src="imageUrl + 'total_reward.webp?x-oss-process=image/format,webp'"
          alt=""
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { useAgentStore } from "@/stores/user";
import { useCommonStore } from "@/stores/common";
export default {
  data() {
    return {
      imageUrl:
        "https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/ib_event/ib6/images/",
      agentStore: useAgentStore(),
      commonStore: useCommonStore(),
    };
  },
};
</script>

<style lang="scss" scoped>
$cdn: "https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/ib_event/ib6/images/";

#total_reward_description {
  padding-top: 29px;
  padding-bottom: 28px;
  // background-image: linear-gradient(to left, rgba(255, 255, 255, 0) 81%, rgba(255, 255, 255, 0.7) 58%, rgba(255, 255, 255, 0.7) 38%, rgba(255, 255, 255, 0) 15%), linear-gradient(to bottom, #fdf1dd, rgb(255 255 255) 62%, rgba(255, 253, 234, 0.53) 36%, rgb(248 224 183) 21%, rgb(249 236 208) -3%, #fff -14%), linear-gradient(to bottom, #fff, #fff);

  p {
    margin: 0;
  }

  .container {
    padding: 0 32px;
  }

  .title_wrapper {
    background: url($cdn + "bg_total_reward_description_title.webp?x-oss-process=image/format,webp")
      no-repeat center center;
    margin-bottom: 15px;

    p {
      background-color: #fff;
      border-radius: 35px;
      padding: 5px 4px;
    }

    span {
      display: block;
      text-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.25);
      font-family: MicrosoftYaHeiSemibold;
      font-size: 20px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 1px;
      text-align: center;
      color: #ee0a24;
      padding: 14px 22px 0px 19px;
      position: relative;
      border-image-source: linear-gradient(
        60deg,
        #f5d7ca 27%,
        #fff 40%,
        #fff4e1 49%,
        #f5d7ca 68%
      );
      // border-image-slice: 1;
      background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.4)
        ),
        linear-gradient(60deg, #f5d7ca 27%, #fff 40%, #fff4e1 49%, #f5d7ca 68%);
      background-origin: border-box;
      border-radius: 35px;
      z-index: 1;

      &:after {
        content: "";
        width: 99%;
        height: 91%;
        position: absolute;
        z-index: -1;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        border-radius: 30px;
        background-image: linear-gradient(to bottom, #ffebc6 -11%, #fff 107%);
        border-color: #f5d7ca;
        border-width: 5px;
      }
    }
  }

  .content_wrapper {
    // max-width: 300px;
    margin: 0 auto 0 7px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .content {
      .title {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
        margin-bottom: 4px;
      }

      img {
        max-width: 188px;
      }
    }

    img {
      max-width: 111px;
    }
  }
}
</style>
